module.exports = __webpack_public_path__ + "img/step-4.310cf6ff.jpg";